<script setup>
import {Permissions} from "@/Utils/Permissions";
import InvoiceSearchComponent from "@/Components/Invoices/InvoiceSearchComponent.vue";
import {useRoute} from "vue-router";
const route = useRoute();
</script>

<template>
  <v-row v-if="Permissions.checkPermissions(['claims.search'])" >
    <v-col cols="12">
      <InvoiceSearchComponent/>
    </v-col>
  </v-row>
</template>

<style scoped>

</style>